/**
 * Check whether a value is nullish (null or undefined).
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Nullish_coalescing
 */
export function isNullish(value) {
    return value === null || value === undefined;
}
/**
 * Create a deferred promise, which can be resolved externally.
 * @see https://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
 */
export function deferredPromise() {
    let res = () => { };
    let rej = () => { };
    const promise = new Promise((resolve, reject) => {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
/**
 * Normalize errors from Monarch and Preamp.
 */
export function normalizeError(err) {
    if (!err) {
        return null;
    }
    const result = {
        message: 'Unknown error',
    };
    if (typeof err.error === 'object') {
        result.message = err.error.error;
        if (err.error.traceId) {
            result.traceId = err.error.traceId;
        }
    }
    if (typeof err.error === 'string') {
        result.message = err.error;
        if ('meta' in err) {
            result.timeout = err.meta?.timeout;
        }
    }
    return result;
}
